
import { supabaseWorker } from '@/integrations/supabase/workerClient';
import { SearchResult } from './types';
import { calculateRelevance, detectQueryType } from './utils';
import { getDisplayId } from '@/utils/displayId';

export const searchOrders = async (query: string, limit: number): Promise<SearchResult[]> => {
  const queryType = detectQueryType(query);

  type DbOrderPick = {
    id: string;
    public_id: string | null;
    status: string | null;
    created_at: string;
    total_amount: number | null;
    notes: string | null;
  };

  const baseSelect = () =>
    supabaseWorker
      .from('orders')
      .select('id, public_id, status, created_at, total_amount, notes');

  let queries: Array<ReturnType<typeof baseSelect>> = [];

  if (queryType === 'id') {
    queries = [
      baseSelect().eq('id', query).limit(limit),
      baseSelect().ilike('id', `${query}%`).limit(limit),
      baseSelect().ilike('notes', `%${query}%`).limit(limit),
    ];
  } else {
    queries = [
      baseSelect().ilike('notes', `%${query}%`).limit(limit),
    ];
  }

  const results = await Promise.all(
    queries.map(async (q) => {
      const { data, error } = await q;
      if (error) {
        // eslint-disable-next-line no-console
        console.error('[GlobalSearch][orders] source error:', error);
      }
      return (Array.isArray(data) ? (data as DbOrderPick[]) : []) as DbOrderPick[];
    })
  );
  const rows: DbOrderPick[] = results.flat();
  if (rows.length === 0 && results.length > 0) {
    // Если все подзапросы пустые и были ошибки — сигнализируем об общей ошибке источника
    // Примечание: выявить наличие ошибок мы можем по консольным логам выше; здесь не дублируем
    // чтобы не заспамить UI, полагаемся на searchService allSettled для graceful degradation
  }
  const unique = Array.from(new Map(rows.map(r => [r.id, r])).values()).slice(0, limit);

  return unique.map(dbOrder => {
    const displayId = getDisplayId(dbOrder, 6);
    return ({
      id: dbOrder.id,
      type: 'order' as const,
      title: `Заказ ${displayId}`,
      subtitle: 'Заказ',
      description: `Сумма: ${dbOrder.total_amount || 0} ₽`,
      icon: 'ShoppingCart',
      url: `/orders`,
      relevance: calculateRelevance(query, [dbOrder.id, dbOrder.notes || ''], queryType),
      createdAt: dbOrder.created_at,
      status: dbOrder.status
    });
  });
};

